<template>
  <div class="screenshot-container">
    <!-- 查询区域 -->
    <div class="query-group">
      <label>输入用户姓名：</label>
      <el-input
        v-model="searchName"
        placeholder="请输入要查询的用户姓名"
        style="width: 260px"
        @keyup.enter="getScreenshotList"
      />
      <el-button type="primary" @click="getScreenshotList" :loading="loading">
        查询截图
      </el-button>
    </div>

    <!-- 截图选择下拉框 -->
    <div class="select-group" v-if="screenshotList.length > 0">
      <label>选择要查看的截图：</label>
      <el-select
        v-model="selectedPicName"
        placeholder="点击选择一张截图"
        style="width: 360px"
        @change="showImage"
      >
        <el-option
          v-for="item in screenshotList"
          :key="item"
          :label="item"
          :value="item"
        />
      </el-select>
    </div>

    <!-- 图片展示区域 -->
    <div class="image-show-box" v-if="imageUrl">
      <p class="tip">当前查看：{{ selectedPicName }}</p>
      <img :src="imageUrl" class="show-image" alt="用户截图" />
    </div>

    <!-- 空状态 -->
    <div class="empty-tip" v-else-if="searched">
      请选择一张截图进行查看
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import axios from 'axios';
import { ElMessage } from 'element-plus';

const searchName = ref('');
const loading = ref(false);
const screenshotList = ref([]);
const selectedPicName = ref('');
const imageUrl = ref('');
const searched = ref(false);

// 1. 根据姓名获取所有截图文件名
const getScreenshotList = async () => {
  if (!searchName.value.trim()) {
    ElMessage.warning('请输入用户姓名');
    return;
  }

  loading.value = true;
  screenshotList.value = [];
  imageUrl.value = '';
  selectedPicName.value = '';
  searched.value = true;

  try {
    const res = await axios.get('https://log-inter.wuxiahaojie.com/api/FileUpload/allData', {
      params: { name: searchName.value }
    });

    // 👇 这里已经改成适配你后端返回格式：code + data
    if (res.data && res.data.code === 200 && Array.isArray(res.data.data)) {
      screenshotList.value = res.data.data; // 关键修改

      if (screenshotList.value.length === 0) {
        ElMessage.info('该用户暂无截图');
      } else {
        ElMessage.success(`找到 ${screenshotList.value.length} 张截图`);
      }
    } else {
      ElMessage.warning('接口返回格式异常');
    }
  } catch (err) {
    ElMessage.error('查询失败：' + err.message);
  } finally {
    loading.value = false;
  }
};

// 2. 选择图片后展示
const showImage = () => {
  // 接口直接返回图片流，img 可直接显示
  imageUrl.value = `https://log-inter.wuxiahaojie.com/api/FileUpload/oneData?PictureName=${selectedPicName.value}`;
};
</script>

<style scoped>
.screenshot-container {
  padding: 10px;
}

.query-group {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.select-group {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.image-show-box {
  margin-top: 10px;
}

.tip {
  color: #ccc;
  font-size: 13px;
  margin-bottom: 8px;
}

.show-image {
  max-width: 100%;
  max-height: 600px;
  border-radius: 6px;
  border: 1px solid #444;
}

.empty-tip {
  color: #999;
  padding: 40px 0;
  text-align: center;
}

label {
  color: #e2e8f0;
  font-size: 14px;
}
</style>